import React from "react";
import { observer } from "mobx-react";
import { MusicalWorkLinkCreateStore } from "../../store";
import { MusicalWorkLinkCreateForm } from "./MusicalWorkLinkCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type MusicalWorkLinkCreateProps = {
  musicalWorkLinkCreateStore: MusicalWorkLinkCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const MusicalWorkLinkCreate: React.FC<MusicalWorkLinkCreateProps> =
  observer(
    ({ musicalWorkLinkCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={musicalWorkLinkCreateStore.isSaving} />
          <MusicalWorkLinkCreateForm
            musicalWorkLinkCreateStore={musicalWorkLinkCreateStore}
            urlError={musicalWorkLinkCreateStore.errors.url?.message}
            onUrlChange={(value: string) => {
              musicalWorkLinkCreateStore.setUrlValue(value);
            }}
            url={musicalWorkLinkCreateStore.entityValues.url}
            platformError={musicalWorkLinkCreateStore.errors.platform?.message}
            onPlatformChange={(value) => {
              musicalWorkLinkCreateStore.setPlatformValue(value);
            }}
            platformSelectedValue={
              musicalWorkLinkCreateStore.entityValues.showPlatform
            }
            onPlatformSelected={(value) => {
              musicalWorkLinkCreateStore.setSelectedPlatform(value);
            }}
            platformOptions={musicalWorkLinkCreateStore.getPlatformOptions()}
            typeError={musicalWorkLinkCreateStore.errors.type?.message}
            onTypeChange={(value) => {
              musicalWorkLinkCreateStore.setTypeValue(value);
            }}
            typeSelectedValue={musicalWorkLinkCreateStore.entityValues.showType}
            onTypeSelected={(value) => {
              musicalWorkLinkCreateStore.setSelectedType(value);
            }}
            typeOptions={musicalWorkLinkCreateStore.getTypeOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={musicalWorkLinkCreateStore.isProcessing}
            onSave={() => musicalWorkLinkCreateStore.saveNewMusicalWorkLink()}
            onCancel={() =>
              musicalWorkLinkCreateStore.cancelNewMusicalWorkLink()
            }
          />
          <ErrorDialog
            open={musicalWorkLinkCreateStore.errorDialogOpened}
            title={musicalWorkLinkCreateStore.errorTitle}
            description={musicalWorkLinkCreateStore.errorDescription}
            onClose={() => musicalWorkLinkCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
